export function update(state = {isOk:false, error:null, isLoading: false}, action) {

    switch (action.type) {
        case 'UPDATE_DATA_PHONE':
            return {...state, isOk: false, isLoading:true};
        case 'UPDATE_DATA_PHONE_SUCCESS':
            return {...state, isOk: true, isLoading:false, ...action.data};
        case 'UPDATE_DATA_PHONE_FORBIDDEN':
            return {...state, isOk: false, error: action.data, isLoading:false};
        case 'UPDATE_DATA_PHONE_BAD_REQUEST':
            return {...state, isOk: false, error: action.data, isLoading:false};
        case 'UPDATE_DATA_PHONE_NOT_FOUND':
            return {...state, isOk: false, error: action.data, isLoading:false};
        case 'UPDATE_DATA_PHONE_VALIDATION_ERROR':
            return {...state, isOk: false, error: action.data, isLoading:false};
            case 'UPDATE_DATA_PHONE_TOO_MANY_REQUEST':
            return {...state, isOk: false, error: action.data, isLoading:false};
        case 'UPDATE_DATA_PHONE_BLOCKED':
            return {...state, isOk: false, error: action.data, isLoading:false};
    }
    return state;
}